module.exports = __webpack_public_path__ + "static/about-shape1-fac27986c9fb7e892a8553d61b77e416.png";